export default __webpack_public_path__ + "static/media/Location.95f269ce.svg";